import React from 'react';

import PropTypes from 'prop-types';

import { RateBrowserConfigurationFormContainer } from './container';
import { useRateViewerContext } from '../../../rate-viewer/rate-viewer-context-provider';

export const RateBrowserConfigurationFormContextContainer = ({ isFromCSWRateBrowserClick = false, onScaleRead = null }) => {
  const { rateViewerKey, browseRates } = useRateViewerContext();

  return (
    <RateBrowserConfigurationFormContainer
      isFromCSWRateBrowserClick={isFromCSWRateBrowserClick}
      onBrowseRates={browseRates}
      onScaleRead={onScaleRead}
      rateViewerKey={rateViewerKey}
    />
  );
};

RateBrowserConfigurationFormContextContainer.propTypes = {
  isFromCSWRateBrowserClick: PropTypes.bool,
  onScaleRead: PropTypes.func,
};
